import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  headStart: {
    display: 'flex',
    alignItems: 'center',
  },
  headIcon: {
    position: 'relative',
    marginRight: '1rem',
    minWidth: '35px',
  },
  labelText: {
    color: theme.palette.gray.inputPlaceholder,
    fontSize: '1rem',
  },
  deleteText: {
    color: theme.palette.error.main,
    cursor: 'pointer',
  },
  signerName: {
    fontSize: '1.25rem',
    color: theme.palette.black.main,
  },
  sectionSecondaryTitle: {
    fontSize: '1rem',
  },
  personIndexContainer: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    width: '1.2em',
    height: '1.2em',
    alignSelf: 'end',
    position: 'absolute',
    left: '1rem',
    bottom: '-0.1rem',
    border: `3px solid ${theme.palette.white.efesBackgroundLight}`,
    boxSizing: 'content-box',
  },
  personIndex: {
    fontSize: '0.8em',
    fontWeight: 'bold',
    textAlign: 'center',
    color: theme.palette.white.main,
  },
  hasAddedSigner: {
    float: 'right',
  },
}));

export default useStyles;
